export default __webpack_public_path__ + "static/video-img-6842c8c010c449b2e56b84cb79e39535.png";